export default function BackArrowIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <g clipPath='url(#clip0_622_1087)'>
        <path
          d='M17.1663 9.16671H7.02467L11.683 4.50837L10.4997 3.33337L3.83301 10L10.4997 16.6667L11.6747 15.4917L7.02467 10.8334H17.1663V9.16671Z'
          fill='#316CF4'
        />
      </g>
      <defs>
        <clipPath id='clip0_622_1087'>
          <rect
            width='20'
            height='20'
            fill='white'
            transform='translate(0.5)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}
